import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { HttpService } from "./http.service";
import { LoaderService } from './loader.service';

export function httpFactory(
  backend: XHRBackend,
  defaultOptions: RequestOptions, loaderService:LoaderService) {
    return new HttpService(backend, defaultOptions,loaderService) }


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/services/http.factory.ts